import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "../component/Header";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, logoutUser } from "../redux/auth/actions";

const ProtectedRoutes = () => {
  const userSuccess = useSelector((state) => state.auth.user.success);
  const user = useSelector((state) => state.auth.user.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onLogout = () => dispatch(logoutUser());

  useEffect(() => {
    if (!userSuccess && localStorage.getItem("sessionToken")) {
      dispatch(getCurrentUser());
    }
  }, []);

  useEffect(() => {
    if (!userSuccess && !localStorage.getItem("sessionToken")) {
      navigate("/login");
    }
  }, [userSuccess, navigate]);

  return (
    <div className="flex flex-col">
      <div className="bg-cyan-900 h-5"></div>
      <Header user={user} onLogout={onLogout} />
      <div className="container mx-auto z-20">
        <Outlet />
      </div>
    </div>
  );
};
export default ProtectedRoutes;
